import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReplaySubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from '../../services/user.service';
import { CompanyService } from '../../services/company.service';

@Component({
    selector: 'app-delete-company',
    templateUrl: './delete-company.component.html',
    styleUrls: ['./delete-company.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeleteCompanyComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  response: any;
  config: any;
  companies: any[] = [];
  selectedCompanyId: any = null;
  deletedCompany: any;

  constructor(
    private mdr: MatDialogRef<DeleteCompanyComponent>,
    private snackBar: MatSnackBar,
    public userService: UserService,
    public companyService: CompanyService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.config = data;
    this.deletedCompany = data?.deletedCompany || null;

    this.companies = (data?.allCompanies || [])
      .filter((company: any) => company.id !== this.deletedCompany?.id);
  }

  ngOnInit(): void {
  }

deleteCompany(): void {
  if (this.selectedCompanyId === null) {
    this.snackBar.open(
      'Please select an alternate company to transfer projects and records.',
      'Close',
      {
        duration: 3000,
        verticalPosition: 'top',
        panelClass: ['default-snackbar'],
      }
    );
    return;
  }

  this.companyService
    .deleteCompany(this.deletedCompany.id, this.selectedCompanyId)
    .subscribe({
      next: () => {
        this.snackBar.open(
          'Company deleted successfully.',
          'Close',
          {
            duration: 3000,
            verticalPosition: 'top',
            panelClass: ['default-snackbar'],
          }
        );

        // close dialog and notify parent to refresh list
        this.mdr.close(true);
      },
      error: (error) => {
        console.error('Delete company failed:', error);

        this.snackBar.open(
          'Failed to delete company. Please try again.',
          'Close',
          {
            duration: 3000,
            verticalPosition: 'top',
            panelClass: ['error-snackbar'],
          }
        );
      }
    });
  }

  public closeDialog(): void {
    this.mdr.close();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
